import { baseUrl as envBaseUrl, imageServiceUrl as envImageServiceUrl } from '../config/environment';

// Export from environment configuration
// This allows CI/CD pipelines to set different URLs via environment variables
export const baseUrl = envBaseUrl;
export const imageServiceUrl = envImageServiceUrl;

// Legacy configuration (commented out for reference)
// export const baseUrl = 'https://apitest.climate-crusaders.com';
// export const imageServiceUrl = 'https://apitest.climate-crusaders.com';
// export const baseUrl = 'http://15.207.69.142:5050';
// export const baseUrl = 'http://3.111.146.234:5050';
// export const baseUrl = 'http://localhost:5050';
// export const imageServiceUrl = 'http://localhost:5050';
